<template>
  <BackNav :title="$t('message.title')" />
  <ul class="group">
    <li class="item" v-for="item of messageList" :key="item.id" @click="getMessageDetailHandler(item)">
      {{ item.title }}
      <van-icon name="arrow" class="item-icon" />
    </li>
  </ul>
  <van-dialog v-model:show="showDialog" :title="title" show-cancel-button>
    <div style="padding: 2.66667vw; font-size: 2.66667vw">{{ content }}</div>
  </van-dialog>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import BackNav from '@/components/BackNav';
import { MessageService } from '@/services';
const messageList = ref([]);

const getMessage = async () => {
  const { code, result } = await MessageService.messageListApi({});
  console.log(code, result);
  if (Object.is(code, 0)) {
    messageList.value = result.data;
  }
};
onMounted(() => {
  getMessage();
});

const showDialog = ref(false);
const title = ref('');
const content = ref('');
const getMessageDetailHandler = async (item) => {
  console.log(item);
  title.value = item.title;
  const { code, result } = await MessageService.getMessageByIdApi(item.id);
  if (Object.is(code, 0)) {
    console.log(result);
    showDialog.value = true;
    content.value = result.content;
  }
};
</script>

<style lang="scss" scoped>
.group {
  padding: 20px;
  box-sizing: border-box;
  .item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    line-height: 100px;
    border-bottom: 1px solid #f5f6f7;
    color: #555;
    .item-icon {
      font-size: 50px;
      color: #555;
    }
  }
}
</style>
